import React from 'react';
import { TextField } from 'components/forms';
import { P } from 'components/text';

const NonResident = () => {
  return (
    <>
      <P>
        Please enter your name and address as it appears on official documents.
      </P>

      <TextField name="individual.first_name" label="First name" required />

      <TextField name="individual.middle_name" label="Middle name" />

      <TextField name="individual.last_name" label="Last name" required />

      <TextField name="individual.phone" label="Phone" required />

      <TextField name="individual.address.address" label="Address" required />

      <TextField
        name="individual.address.address_2"
        label="Address line 2 (optional)"
      />

      <TextField name={`individual.address.city`} label="City" required />

      <TextField
        name={`individual.address.state`}
        label="State/Province/Region"
        required
      />

      <TextField
        name={`individual.address.zip_postal_code`}
        label="Zip/Postal code"
        required
      />

      <TextField name={`individual.address.country`} label="Country" disabled />
    </>
  );
};

export default NonResident;
